var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from 'react';
import { toast } from 'react-toastify';
import Button from '../../..//Button';
import FormRow from '../../..//Form/Row';
import TextInput from '../../../Fields/TextInput';
import { Fields } from '../../../../utils/Fields';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { serialize } from 'object-to-formdata';
import axiosInstance from '../../../../config/axios';
import { api } from '../../../../config/api';
import { useValidation } from '../../../../hooks/useValidation';
import FavoriteHeader from '../../FavoriteHeader';
import { ChevronLeft } from 'react-feather';
var FavoriteStepForm = function (_a) {
    var onSuccess = _a.onSuccess, onCancel = _a.onCancel, title = _a.title, favoriteList = _a.favoriteList;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var textRequired = useValidation().textRequired;
    var schema = yup.object().shape({
        name: textRequired,
    });
    var _c = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            name: (favoriteList === null || favoriteList === void 0 ? void 0 : favoriteList.name) ? favoriteList.name : '',
        },
    }), handleSubmit = _c.handleSubmit, control = _c.control, _d = _c.formState, isDirty = _d.isDirty, isValid = _d.isValid;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var url, successMessage, formData, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    url = api.favorites.new;
                    successMessage = 'Liste créée';
                    if (favoriteList) {
                        data.id = favoriteList.id;
                        url = api.favorites.update;
                        successMessage = 'Liste mise à jour';
                    }
                    formData = serialize(data, { indices: true });
                    return [4 /*yield*/, axiosInstance.post(url, formData)];
                case 2:
                    response = _a.sent();
                    toast.success(successMessage);
                    if (onSuccess) {
                        onSuccess(response);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (<>
      <FavoriteHeader text={title} className="text-center">
        <button onClick={onCancel}>
          <ChevronLeft className={"absolute left-0 top-1 m-6"}/>
        </button>
      </FavoriteHeader>


      <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col mt-6">
            <div className="mb-6">
              <FormRow>
                <TextInput label="Nom de la liste" type={Fields.TEXT} name="name" placeholder="Ex : Management" control={control} required/>
              </FormRow>
            </div>
            <Button submit loading={loading} className="self-start">Créer</Button>
          </div>
      </form>
    </>);
};
export default FavoriteStepForm;
